import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../service/udnick';
import { IFilter } from 'store/ducks/movimentacoes/types';

export const Pedidos = {
  getAllData: (
    codCdd: number | undefined,
    filtro: IFilter | undefined,
    parceiros: number | undefined,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService(
      'getPedidos',
      {
        codCdd,
        filtro,
        parceiros,
      },
      { tamanhoPagina }
    ),
};

export const EstoqueLoteByPagador = {
  getLotesByProdutoPagador: (
    inscricaoEstadual: number | undefined,
    centroDistribuicao: number | undefined,
    codProduto: number | undefined,
    codPagador: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getLotesByProdutoPagador', {
      inscricaoEstadual,
      centroDistribuicao,
      codProduto,
      codPagador,
    }),
};

export const EstoqueTransportadorasServices = {
  getTransportadoras: (): Promise<AxiosResponse> => UDNICK.callService('getTransportadoras', {}),
};

export const EstoqueSelecionarEstado = {
  getEstados: (): Promise<AxiosResponse> => UDNICK.callService('getEstados', {}),
};

export const EstoqueSelecionarCidade = {
  getCidades: (codUf: number | undefined): Promise<AxiosResponse> =>
    UDNICK.callService('getCidades', { codUf }),
};

export const EstoqueDetalhesService = {
  getDetalheEstoque: (
    inscricaoEstadual: number | undefined,
    centroDistribuicao: number | undefined,
    codProduto: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getDetalheEstoque', { inscricaoEstadual, centroDistribuicao, codProduto }),
};

export const EnderecoService = {
  getEnderecos: (inscricoesEstaduais: number | undefined): Promise<AxiosResponse> =>
    UDNICK.callService('getEnderecos', { inscricoesEstaduais }),
};

export const CriaTransportadora = {
  criaTransportadora: (
    inscricaoEstadual: number | undefined,
    nome: string | undefined,
    cnpj: string | undefined,
    codCid: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaTransportadora', { inscricaoEstadual, nome, cnpj, codCid }),
};

export const CriaEndereco = {
  criaEnderecoParceiro: (
    codParceiro: number | undefined,
    endereco: {
      cep: string | undefined;
      numEndereco: number | undefined;
      nomeEndereco: string | undefined;
      bairro: string | undefined;
      cidade: string | undefined;
      uf: string | undefined;
      complemento: string | undefined;
    }
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaEnderecoParceiro', { codParceiro, endereco }),
};
